import dayjs, { Dayjs } from 'dayjs';

import { DATE_PICKER_FORMAT } from '../constants';

/**
 * Generates an array of dates between a given start date and end date, inclusive,
 * and formats them into strings according to a specific format.
 */
const generateDateRange = (
  startDate: Dayjs,
  endDate: Dayjs,
  format = DATE_PICKER_FORMAT,
) => {
  const min = startDate.toDate();
  const max = endDate.toDate();
  const oneDay = 24 * 60 * 60 * 1000;

  const dates = Array.from(
    { length: Math.floor((+max - +min) / oneDay) + 1 },
    (_, index) => new Date(min.getTime() + index * oneDay),
  );

  return dates.map(date => dayjs(date).format(format));
};

export default generateDateRange;
